module.exports = __webpack_public_path__ + "static/media/imageDarkMode.fc39bb1c.svg";